import { csrfHeaders } from '@/components/csrf';

import { reloadPage } from './browser';

export const MODE_PATH = '/api/v4/single_root/mode';

// Turning the mode off is always allowed server side; reload so Rails serves legacy.
export const turnOffSingleRoot = async (
  url: string = MODE_PATH,
  reload: () => void = reloadPage
): Promise<void> => {
  const response = await fetch(url, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...csrfHeaders()
    },
    body: JSON.stringify({ enabled: false })
  });
  if (!response.ok) throw new Error(`Could not turn off Single-root (HTTP ${response.status})`);
  reload();
};
